var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"bg-primary-color",on:{"click":_vm.toggleLanguage}},[_vm._v(" "+_vm._s(_vm.$store.state.language === "en" ? "En Français" : "View in English")+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }